// extracted by mini-css-extract-plugin
export default {"container":"eD_fi","text":"nvSGZ","placeholder":"jaIXo"};